import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section footer-brand">
          <div className="footer-logo">
            <span className="logo-icon">✨</span>
            <span className="logo-text">dailyzodiac.ai</span>
          </div>
          <p className="footer-tagline">{t('footer.tagline')}</p>
        </div>

        <div className="footer-section footer-links">
          <h3>{t('footer.quickLinks')}</h3>
          <ul>
            <li><Link to="/">{t('footer.home')}</Link></li>
            <li><Link to="/about">{t('footer.about')}</Link></li>
            <li><Link to="/contact">{t('footer.contact')}</Link></li>
          </ul>
        </div>

        <div className="footer-section footer-articles">
          <h3>{t('footer.articles')}</h3>
          <ul>
            <li><Link to="/articles/aries-personality">{t('footer.articleAriesPersonality')}</Link></li>
            <li><Link to="/articles/moon-phases-mood">{t('footer.articleMoonPhasesMood')}</Link></li>
            <li><Link to="/articles/zodiac-compatibility">{t('footer.articleZodiacCompatibility')}</Link></li>
            <li><Link to="/articles/mercury-retrograde">{t('footer.articleMercuryRetrograde')}</Link></li>
            <li><Link to="/articles/how-birth-charts-work">{t('footer.articleBirthCharts')}</Link></li>
            <li><Link to="/articles/western-vs-vedic-astrology">{t('footer.articleWesternVsVedic')}</Link></li>
          </ul>
        </div>

        <div className="footer-section footer-legal">
          <h3>{t('footer.legal')}</h3>
          <ul>
            <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
            <li><Link to="/terms">{t('footer.terms')}</Link></li>
            <li><Link to="/cookies">{t('footer.cookies')}</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} dailyzodiac.ai. {t('footer.rights')}</p>
      </div>
    </footer>
  );
}

export default Footer;
